import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";
import { message } from "antd";

//CREATE ACTION
export const deleteEmployeeOTRequest = createAsyncThunk("deleteEmployeeOTRequest", async (requestId, { rejectWithValue }) => {
    try {
        const response = await axiosHttp.get(`requests/overtime/delete/${requestId}`);
        message.success(response.data.message);
        return response.data;
    } catch (err) {
        if (!err.response) {
            throw err;
        }
        message.error(err.response.data.message);
        return rejectWithValue(err.response.data);
    }
});

const EmployeeOTRequestDeleteSlice = createSlice({
    name: "EmployeeOTRequestDeleteSlice",
    initialState: {
        isLoading: false,
        isError: false,
        error: null,
        data: null,
    },

    extraReducers: (builder) => {
        builder.addCase(deleteEmployeeOTRequest.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
        });

        builder.addCase(deleteEmployeeOTRequest.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.data = action.payload;
        });

        builder.addCase(deleteEmployeeOTRequest.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        });
    },
});

export default EmployeeOTRequestDeleteSlice.reducer;
